'use client';

import type { ReactNode } from 'react';

import { AdaptiveGallery } from '@ui/uikit/components/common/AdaptiveGallery';

import styles from './CardsSwiper.module.scss';

interface CardsSwiperProps<T extends { id: string }> {
  items: T[];
  renderItem: (item: T) => ReactNode;
}

export function CardsSwiper<T extends { id: string }>({ items, renderItem }: CardsSwiperProps<T>) {
  return (
    <div className={styles.container}>
      <AdaptiveGallery
        numberOfSlides={4}
        spacing="16px"
        centerSlides={false}
        loopSlides
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={600}
        breakpoints={{
          SMALL: {
            numberOfSlides: 1,
            spacing: '8px',
          },
          MEDIUM: {
            numberOfSlides: 2,
            spacing: '8px',
          },
          LARGE: {
            numberOfSlides: 3,
            spacing: '16px',
          },
        }}
      >
        {items.map((item) => (
          <AdaptiveGallery.Slide key={item.id} stretchHeight>
            {renderItem(item)}
          </AdaptiveGallery.Slide>
        ))}
      </AdaptiveGallery>
    </div>
  );
}
